<template>
  <v-list dense>
    <v-card class="hidden-md-and-up"><client-selector /></v-card>
    <template v-for="item in items">
      <v-layout v-if="item.heading" :key="item.heading" row align-center>
        <v-flex xs6>
          <v-subheader v-if="item.heading"> {{ item.heading }} </v-subheader>
        </v-flex>
        <v-flex xs6 class="text-xs-center">
          <a href="#!" class="body-2 black--text">EDIT</a>
        </v-flex>
      </v-layout>
      <v-list-group
        v-show="isLoggedIn"
        v-else-if="item.children"
        v-model="item.expanded"
        :key="item.module + item.text"
        :icon="item.expanded ? item.icon : item['icon-alt']"
        :prepend-icon="item.folderIcon"
        no-action
      >
        <v-list-tile slot="activator">
          <v-list-tile-content>
            <v-list-tile-title> {{ item.text }} </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>

        <v-list-tile v-for="(child, i) in item.children" :key="i" :to="child.to">
          <v-list-tile-content>
            <v-list-tile-title
              ><v-icon small>{{ child.icon }}</v-icon> {{ child.text }}
            </v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list-group>
      <v-list-tile v-else :key="item.module + item.text" :to="item.to">
        <v-list-tile-action>
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title> {{ item.text }} </v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </template>
  </v-list>
</template>
<script>
import {mapGetters} from 'vuex'
import ClientSelector from './ClientSelector'

export default {
  props: {
    externalItems: {type: Array, required: false},
  },
  data() {
    return {
      dialog: false,
    }
  },
  computed: {
    ...mapGetters({isLoggedIn: 'authentication/isLoggedIn'}),
    ...mapGetters({currentRole: 'authentication/currentRole'}),
    ...mapGetters({currentUsername: 'authentication/currentUsername'}),
    ...mapGetters({filteredItems: 'app/filteredItems'}),
    roleUser: function() {
      return this.currentUsername + '(' + this.currentRole + ')'
    },
    items() {
      return this.externalItems || this.filteredItems
    },
  },
  methods: {
    async logout() {
      await this.$store.dispatch('authentication/logout')
      this.$router.push('/login')
    },
  },
  components: {
    ClientSelector,
  },
}
</script>
